import 'css-chunksrc/client/pages/projectPage/wbsPage/displayToggle/toggleButton/styles.scss';export default {
  "toggleButton": "_toggleButton_n5qmh_1",
  "thumb": "_thumb_n5qmh_10",
  "active": "_active_n5qmh_21",
  "right": "_right_n5qmh_25",
  "activeButton": "_activeButton_n5qmh_29",
  "row": "_row_n5qmh_34",
  "label": "_label_n5qmh_46",
  "icon": "_icon_n5qmh_53",
  "selected": "_selected_n5qmh_61"
};